import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { RouterModule } from '@angular/router';



import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { OfferComponent } from './offer.component';



@NgModule({
    imports: [
        CommonModule,
        AngularFontAwesomeModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [
        OfferComponent
    ],
  
    declarations: [
        OfferComponent
    ],
    providers: [
      
    ],
    entryComponents: [
        OfferComponent,
    ],
  
  })
  export class OfferModule { }

   // required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }